import { parse, stringify } from 'query-string';

export function parseQsSafe<T extends {}>(qs: string, defaultParams: T): T {
  return { ...defaultParams, ...parse(qs) };
}

export { parse, stringify };
